var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"charging-point-search pa-10"},[_c('title-page',{attrs:{"icon":"ico-charging-point"}},[_vm._v(" "+_vm._s(_vm.$t("charging-point.search-charging-point"))+" ")]),_c('charging-point-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }